import { IProvider } from '@/@types'

interface Constants {
  BREAKPOINTS: {
    MOBILE: number
    TABLET: number
    DESKTOP: number
    LG_DESKTOP: number
    LG_XL_DESKTOP: number
  }
  PLANS: {
    ANNUAL: string
    BAH: string
    BLKFRIDAY: string
    EDA_PREMIUM: string
    EDA_PREMIUM_CONT: string
    INE_PREMIUM_IND_BOOGO_2Y: string
    INE_PREMIUM_BOOGO_2Y: string
    LEGACY: string
    MONTHLY: string
    MONTHLY_EJPT: string
    PREMIUM2YR: string
    PREMIUM: string // Plan codes until dev/prod have ID's synced up
    PREMIUM_MONTHLY: string
    PTA: string // deprecated
    EWPT_PREMIUM: string
    SKILL_DIVE_ANNUAL: string
    ECPPT_PREMIUM: string
    SKILL_DIVE_PTA: string
    EWPTX_PREMIUM: string
    EMAPT_PREMIUM: string
    ECTHP_PREMIUM: string
    ECIR_PREMIUM: string
    EJDS_PREMIUM: string
    ESOC_PREMIUM: string
    ESOC_PREMIUM_CONT: string
    EAIS_PREMIUM: string
    EAIS_PREMIUM_CONT: string
    EIAMA_PREMIUM: string
    EIAMA_PREMIUM_CONT: string
    EJPT_FUNDAMENTALS: string
    INE_TCS_BUNDLE: string
    PREMIUM_PLUS: string
  }
  EXTENSIONS: {
    EXAM_EXTENSION: string
  }
  PREMIUM_PLANS: {
    INE_PREMIUM: string
    INE_PREMIUM_IND_BOOGO_2Y: string
    INE_PREMIUM_BOOGO_2Y: string
    INE_PREMIUM_BLACK_FRIDAY_2Y: string
    INE_PREMIUM_DEFENSE: string
    INE_PREMIUM_2Y: string
    INE_PREMIUM_BAH_PLUS: string
    INE_PREMIUM_MONTHLY: string
    INE_PREMIUM_EDA: string
    INE_PREMIUM_EDA_CONT: string
    INE_PREMIUM_EWPT_PREMIUM: string
    INE_LEAP_YEAR_BUNDLE: string
    INE_JUNE_SAVINGS_BUNDLE: string
    INE_PREMIUM_ECPPT: string
    INE_PREMIUM_EWPTX: string
    INE_PREMIUM_EMAPT: string
    INE_TCS_BUNDLE: string
    INE_PREMIUM_PLUS: string
    SUMMER_SAVINGS_BUNDLE: string
    ECTHP_PREMIUM: string
    ECIR_PREMIUM: string
    EJDS_PREMIUM: string
    INE_PREMIUM_ESOC: string
    INE_PREMIUM_ESOC_CONT: string
    INE_PREMIUM_EAIS: string
    INE_PREMIUM_EAIS_CONT: string
    INE_PREMIUM_EIAMA: string
    INE_PREMIUM_EIAMA_CONT: string
  }
  BUSINESS_PLANS: {
    PLAN_PROFESSIONAL: string
    PLAN_ENTERPRISE: string
    PLAN_ENTERPRISE_LAB: string
  }
  PLAN_STATES: {
    expired: string
    active: string
    terminated: string
    cancelled: string
    pending: string
    canceled: string
  }
  VOUCHERS: {
    ICCA: String
    EJPT: String
    EDA: String
    ECDFP: String
    ECIR: String
    ECPPT: String
    ECTHP: String
    EMAPT: String
    EWPTX: String
    EWPT: String
    ECPPT3: String
    EJDS: String
    ESOC: String
    EAIS: String
    EIAMA: String
  }
  COUPONS: {
    CMLVT2525: {
      code: string
      percentage: number
    }
    CMCERTPLUS25: {
      code: string
      percentage: number
    }
    JUNE26PREM200: {
      code: string
    }
    JUNE26FUND100: {
      code: string
    }
    EAISBUNDLE626: {
      code: string
    }
  }
  CYBER_MONDAY_BUSINESS_RESTRICTED_COUPONS: Array<string>
  CYBER_MONDAY_SAVINGS_COUPONS: Array<string>
  VOUCHERS_TOOLTIP: string
  LIVE_VIRTUAL_TRAININGS: {
    LVT_ADV_NET_AUTOMATION: string
    LVT_CCIE_SECURITY: string
    LVT_CISCO_ACI: string
    LVT_CCNP_ENCOR: string
    LVT_CCIE_EI: string
  }
  SKILL_DIVE_LEARNING_AREAS: {
    NETWORKING: String
    CYBER_SECURITY: String
    CLOUD: String
  }
  SKILL_DIVE_PLANS: Array<string>
  BLACK_FRIDAY_PRODUCT_BUNDLES: {
    INE_BLACK_FRIDAY_BUNDLE_ONE: string
    INE_BLACK_FRIDAY_BUNDLE_TWO: string
    INE_BLACK_FRIDAY_BUNDLE_THREE: string
    INE_BLACK_FRIDAY_BUNDLE_SKILL_DIVE: string
    INE_CYBER_MONDAY_SKILL_DIVE: string
    INE_FUND_ANNUAL_1YR: string
    ERRORS: {
      BUNDLE_ERROR: string
      BUNDLE_ERROR_VOUCHER: string
      BUNDLE_ERROR_SD: string
    }
  }
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES: {
    INE_LEAP_YEAR_BUNDLE: string
    ERRORS: {
      BUNDLE_ERROR: string
      BUNDLE_ERROR_VOUCHER: string
    }
  }
  TCS_PROMO_PRODUCT_BUNDLES: {
    INE_TCS_BUNDLE: string
    ERRORS: {
      BUNDLE_ERROR: string
      BUNDLE_ERROR_VOUCHER: string
    }
  }
  SUMMER_SAVINGS_BUNDLE: {
    INE_SUMMER_SAVINGS_BUNDLE: string
    ERRORS: {
      BUNDLE_ERROR: string
      BUNDLE_ERROR_VOUCHER: string
    }
  }
  LINKS: {
    PROMO_QUICKSTART: string
    PROMO_2024_EOY_ENTERPRISE: string
    SPRING_SAVINGS_2025: string
    SPRING_SAVINGS_2025_PROMO_PAGE: string
    CERTIFICATION_TRAINING_BUNDLES: string
  }
  SUPPORT: {
    CONTACT_EMAIL: string
    CONTACT_LINK_TEXT: string
  }
  PRODUCT_TYPES: {
    SUBSCRIPTION: string
    CERTIFICATION: string
    CERTIFICATE: string
    LVT: string
    BUNDLE: string
    PLAN: string
  }
  CATALOG_TYPES: {
    CERTIFICATION_BUNDLE: string
  }
  TIERS: {
    FUNDAMENTALS: string
    PREMIUM: string
    PREMIUM_PLUS: string
  }
  NAV_PILLS: Array<string>
  STEPS: Array<string>
  ROUTING_RULES: {
    MUST_HAVE_SHOPPED: Array<string> // Route names
  }
  INTERESTS: Array<string> // Pass ID's
  KNOWN_API_ERRORS: Array<string>
  UTM_VARS: Array<string>
  PAYMENT_METHODS: Array<string>
  PAYMENT_METHODS_LIST: { CREDIT_CARD: string; PAYPAL: string }
  CERTIFICATIONS: {
    ATTEMPT_STATUS: {
      IN_PROGRESS: String
      REVIEW: String
      FINISHED: String
      TIMEDOUT: String
    }
    STATUS: {
      DRAFT: String
      PUBLISHED: String
      ARCHIVED: String
      UNPUBLISHED: String
      COMING_SOON: String
    }
    ALERTS: {
      ALERT_AT_10: String
      ALERT_AT_30: String
      ALERT_AT_45: String
    }
  }
  AUTH_PROVIDERS: Array<IProvider>
  SHOP_VIEW: {
    B2B_OFFER: string
    B2C_OFFER: string
  }
  HUBSPOT: {
    HERO_BANNER: {
      ID: string
      URL: string
      IMG: string
    }
    B2B_BANNER: {
      ID: string
      URL: string
      IMG: string
    }
    SMALL_PRINT: {
      ID: string
      URL: string
      IMG: string
    }
  }
  CART_SAVED_HOURS_LIMIT: number
  GUEST_USER_STORAGE_KEY: string
}

const hubspotPortalIdEnv =
  (process.env.VUE_APP_ENVIRONMENT || '').toLowerCase() === 'production'
    ? process.env.VUE_APP_HUBSPOT_PORTAL_ID
    : process.env.VUE_APP_HUBSPOT_DEVELOPMENT_PORTAL_ID

const HUBSPOT_PORTAL_ID = hubspotPortalIdEnv || ''

const CONSTANTS: Constants = {
  BREAKPOINTS: {
    MOBILE: 768,
    TABLET: 1236,
    DESKTOP: 1350,
    LG_DESKTOP: 1800,
    LG_XL_DESKTOP: 2560,
  },
  PLANS: {
    ANNUAL: 'fundamentals_annual',
    BAH: 'bah_premium_plus',
    BLKFRIDAY: 'ine-ind-black-friday-2021-bogo-2yr',
    EDA_PREMIUM: 'eda_premium',
    EDA_PREMIUM_CONT: 'eda_premium_cont',
    INE_PREMIUM_IND_BOOGO_2Y: 'ine-ind-plan-boogo-2yr',
    INE_PREMIUM_BOOGO_2Y: 'ine_premium_2_year',
    LEGACY: 'ine_legacy_streaming',
    MONTHLY: 'fundamentals_monthly',
    MONTHLY_EJPT: 'ejptv2_funda_monthly',
    PREMIUM2YR: '2_year_premium',
    PREMIUM: 'ine_premium',
    PREMIUM_MONTHLY: 'premium_monthly',
    PTA: 'pta-ind-premium-defense-bundle-1yr', // deprecated
    EWPT_PREMIUM: 'ewpt_premium',
    SKILL_DIVE_ANNUAL: 'skill_dive_annual',
    ECPPT_PREMIUM: 'ecppt_premium',
    SKILL_DIVE_PTA: 'skill_dive_pta',
    EWPTX_PREMIUM: 'ewptx_premium',
    EMAPT_PREMIUM: 'emapt_premium',
    ECTHP_PREMIUM: 'ecthp_premium',
    ECIR_PREMIUM: 'ecir_premium',
    EJDS_PREMIUM: 'ejds_premium',
    ESOC_PREMIUM: 'esoc_premium',
    ESOC_PREMIUM_CONT: 'esoc_premium_cont',
    EAIS_PREMIUM: 'eais_premium',
    EAIS_PREMIUM_CONT: 'eais_premium_cont',
    EIAMA_PREMIUM: 'eiama_premium',
    EIAMA_PREMIUM_CONT: 'eiama_premium_cont',
    EJPT_FUNDAMENTALS: 'ejpt_fundamentals',
    INE_TCS_BUNDLE: 'traincertifysave2025-1',
    PREMIUM_PLUS: 'premium_plus',
  },
  EXTENSIONS: {
    EXAM_EXTENSION: 'ine-ind-exam-extension',
  },
  PREMIUM_PLANS: {
    INE_PREMIUM: 'ine_premium',
    INE_PREMIUM_IND_BOOGO_2Y: 'ine-ind-plan-boogo-2yr',
    INE_PREMIUM_BOOGO_2Y: 'ine_premium_2_year',
    INE_PREMIUM_BLACK_FRIDAY_2Y: 'ine-ind-black-friday-2021-bogo-2yr',
    INE_PREMIUM_DEFENSE: 'pta-ind-premium-defense-bundle-1yr',
    INE_PREMIUM_2Y: '2_year_premium',
    INE_PREMIUM_BAH_PLUS: 'bah_premium_plus',
    INE_PREMIUM_MONTHLY: 'premium_monthly',
    INE_PREMIUM_EDA: 'eda_premium',
    INE_PREMIUM_EDA_CONT: 'eda_premium_cont',
    INE_PREMIUM_EWPT_PREMIUM: 'ewpt_premium',
    INE_LEAP_YEAR_BUNDLE: 'ine-leap-year-bundle',
    INE_JUNE_SAVINGS_BUNDLE: 'ine-june-promo-bundle',
    INE_PREMIUM_ECPPT: 'ecppt_premium',
    INE_PREMIUM_EWPTX: 'ewptx_premium',
    INE_PREMIUM_EMAPT: 'emapt_premium',
    INE_TCS_BUNDLE: 'traincertifysave2025-1',
    INE_PREMIUM_PLUS: 'premium_plus',
    SUMMER_SAVINGS_BUNDLE: 'ine-june-promo-bundle',
    ECTHP_PREMIUM: 'ecthp_premium',
    ECIR_PREMIUM: 'ecir_premium',
    EJDS_PREMIUM: 'ejds_premium',
    INE_PREMIUM_ESOC: 'esoc_premium',
    INE_PREMIUM_ESOC_CONT: 'esoc_premium_cont',
    INE_PREMIUM_EAIS: 'eais_premium',
    INE_PREMIUM_EAIS_CONT: 'eais_premium_cont',
    INE_PREMIUM_EIAMA: 'eiama_premium',
    INE_PREMIUM_EIAMA_CONT: 'eiama_premium_cont',
  },
  BUSINESS_PLANS: {
    PLAN_PROFESSIONAL: 'Professional',
    PLAN_ENTERPRISE: 'Enterprise',
    PLAN_ENTERPRISE_LAB: 'Enterprise + Lab Experience',
  },
  PLAN_STATES: {
    expired: 'expired',
    active: 'active',
    terminated: 'terminated',
    cancelled: 'cancelled',
    pending: 'pending',
    canceled: 'canceled', // only a few in the backend
  },
  VOUCHERS: {
    ICCA: 'ine-ind-cert-icca-cloud-associate',
    EJPT: 'ine-ind-cert-ejpt-v2',
    EDA: 'ine-ind-cert-eeda',
    ECDFP: 'ine-ind-cert-ecdfp',
    ECIR: 'ine-ind-cert-ecir',
    EJDS: 'ine-ind-cert-ejds',
    ECPPT: 'els-cert-ecppt-v2',
    ECTHP: 'ine-ind-cert-ecthp',
    EMAPT: 'ine-ind-cert-emapt',
    EWPTX: 'ine-ind-cert-ewptx',
    EWPT: 'ine-ind-cert-ewpt',
    ECPPT3: 'ine-ind-cert-ecppt',
    ESOC: 'ine-ind-cert-esoc',
    EAIS: 'ine-ind-cert-eais',
    EIAMA: 'ine-ind-cert-eiama',
  },
  COUPONS: {
    CMLVT2525: {
      code: 'CMLVT2525',
      percentage: 25,
    },
    CMCERTPLUS25: {
      code: 'CMCERTPLUS25',
      percentage: 25,
    },
    JUNE26PREM200: {
      code: 'june26prem200',
    },
    JUNE26FUND100: {
      code: 'june26fund100',
    },
    EAISBUNDLE626: {
      code: 'eaisbundle626',
    },
  },
  CYBER_MONDAY_BUSINESS_RESTRICTED_COUPONS: ['cmlvt2525', 'cmlvt2525_test'],
  CYBER_MONDAY_SAVINGS_COUPONS: [
    'cmlvt2525',
    'cmlvt2525_test',
    'cmcertplus25',
    'cmcertplus25_test',
  ],
  VOUCHERS_TOOLTIP: 'Purchase available for INE subscribers only.',
  LIVE_VIRTUAL_TRAININGS: {
    LVT_ADV_NET_AUTOMATION: 'ine-lvt-net-automation',
    LVT_CCIE_SECURITY: 'ine-lvt-ccie-security',
    LVT_CISCO_ACI: 'ine-lvt-aci',
    LVT_CCNP_ENCOR: 'ine-lvt-ccnp',
    LVT_CCIE_EI: 'ine-lvt-ccie-infrastructure',
  },
  SKILL_DIVE_LEARNING_AREAS: {
    NETWORKING: 'skill_dive_networking',
    CYBER_SECURITY: 'skill_dive_cyber',
    CLOUD: 'skill_dive_cloud',
  },
  SKILL_DIVE_PLANS: ['skill_dive_annual', 'skill_dive_pta', 'premium_plus'],
  BLACK_FRIDAY_PRODUCT_BUNDLES: {
    INE_BLACK_FRIDAY_BUNDLE_ONE: 'ine-black-friday-bundle-1',
    INE_BLACK_FRIDAY_BUNDLE_TWO: 'ine-black-friday-bundle-2',
    INE_BLACK_FRIDAY_BUNDLE_THREE: 'ine-black-friday-bundle-3',
    INE_BLACK_FRIDAY_BUNDLE_SKILL_DIVE: 'ine-cyber-monday-skill-dive',
    INE_CYBER_MONDAY_SKILL_DIVE: 'ine-cyber-monday-bundle',
    INE_FUND_ANNUAL_1YR: 'ine_term_fund_annual_1yr',
    ERRORS: {
      BUNDLE_ERROR: 'bf-bundle-error',
      BUNDLE_ERROR_VOUCHER: 'bf-bundle-error_voucher',
      BUNDLE_ERROR_SD: 'bf-bundle-error_skill-dive-area',
    },
  },
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES: {
    INE_LEAP_YEAR_BUNDLE: 'ine-leap-year-bundle',
    ERRORS: {
      BUNDLE_ERROR: 'ly-bundle-error',
      BUNDLE_ERROR_VOUCHER: 'ly-bundle-error_voucher',
    },
  },
  TCS_PROMO_PRODUCT_BUNDLES: {
    INE_TCS_BUNDLE: 'traincertifysave2025-1',
    ERRORS: {
      BUNDLE_ERROR: 'tcs-bundle-error',
      BUNDLE_ERROR_VOUCHER: 'tcs-bundle-error_voucher',
    },
  },
  SUMMER_SAVINGS_BUNDLE: {
    INE_SUMMER_SAVINGS_BUNDLE: 'ine-june-promo-bundle',
    ERRORS: {
      BUNDLE_ERROR: 'ssb-bundle-error',
      BUNDLE_ERROR_VOUCHER: 'ssb-bundle-error_voucher',
    },
  },
  LINKS: {
    PROMO_QUICKSTART: 'https://learn.ine.com/promo/quickstart',
    PROMO_2024_EOY_ENTERPRISE: 'https://learn.ine.com/promo/2024-enterprise-end-of-year',
    SPRING_SAVINGS_2025: 'https://learn.ine.com/promo/enterprise-flash-sale',
    SPRING_SAVINGS_2025_PROMO_PAGE: 'https://learn.ine.com/promo-spring-into-success',
    CERTIFICATION_TRAINING_BUNDLES: 'https://ine.com/certification-and-training-bundles',
  },
  SUPPORT: {
    CONTACT_EMAIL: 'support@ine.com',
    CONTACT_LINK_TEXT: 'contact support',
  },
  PRODUCT_TYPES: {
    SUBSCRIPTION: 'subscription',
    CERTIFICATION: 'certification',
    CERTIFICATE: 'certificate',
    LVT: 'lvt',
    BUNDLE: 'bundle',
    PLAN: 'plan',
  },
  CATALOG_TYPES: {
    // Products flagged with this catalog_type by GET /products render as fully
    // data-driven certification-prep bundle cards (no per-cert hardcoding).
    CERTIFICATION_BUNDLE: 'certification_bundle',
  },
  TIERS: {
    // Subscription tiers served by GET /products (product_catalog_metadata.tier).
    FUNDAMENTALS: 'fundamentals',
    PREMIUM: 'premium',
    PREMIUM_PLUS: 'premium_plus',
  },
  NAV_PILLS: [
    'subscriptions',
    'certification-prep-bundles',
    'certifications',
    'skill-dive',
    'live-virtual-training',
  ],
  STEPS: ['payment', 'confirmation', 'complete'],
  ROUTING_RULES: {
    MUST_HAVE_SHOPPED: ['payment', 'account', 'confirmation', 'complete'],
  },
  INTERESTS: [
    'a981cebe-f448-11ea-beed-12fac9350b1f',
    '7c38c72d-edf8-3b06-a058-22ef7b4c7025',
    '302eec08-0511-4c87-b2dc-816b46812959',
    '2399d6b6-70bd-3413-b4c7-ffa300ef17b1',
  ],
  KNOWN_API_ERRORS: [
    'Invalid refresh token',
    'Your password includes characters that are not allowed.',
    'Your password must be between 8 and 98 characters long.',
    'Username already exists',
    'Unauthenticated.',
    'Username already exists',
    'Your card must be authenticated with 3-D Secure before continuing.',
    'Your transaction was declined. Please use a different card or contact your bank.',
    'Your transaction was declined due to insufficient funds in your account. Please use a different card or contact your bank.',
    'Please validate information and try again. If the problem persists, please contact your bank.',
    'Your card is not allowed to complete this transaction. Please contact your bank or try another card.',
    'Your card has a temporary hold. Please use a different card or contact your bank.',
    'The security code you entered does not match. Please update the CVV and try again.',
    'The transaction was declined due to invalid data.',
    'Your card number is not valid. Please update your card number.',
    'Your account number is not valid. Please update your account number.',
    'Your payment details were not found. Please update your billing information.',
    'Your credit card is expired, please update your card.',
    'Your expiration date is invalid or does not match.',
    'Your card cannot be accepted. Please contact your issuing bank for details or try another card.',
    'Password is required when registering a new user',
    'Incorrect captcha code',
    '1st coupon code: coupon is not redeemable for any provided subscriptions or charges',
  ],
  UTM_VARS: [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_adgroup',
    'utm_promo',
    'utm_purpose',
    'utm_network',
    'utm_placement',
    'gcl_id',
    'fbcl_id',
    'special_offer',
    'available_plans',
  ],
  PAYMENT_METHODS: ['card', 'paypal'],
  PAYMENT_METHODS_LIST: {
    CREDIT_CARD: 'credit_card',
    PAYPAL: 'paypal_billing_agreement',
  },
  CERTIFICATIONS: {
    ATTEMPT_STATUS: {
      IN_PROGRESS: 'in_progress',
      REVIEW: 'review',
      FINISHED: 'finished',
      TIMEDOUT: 'timedout',
    },
    STATUS: {
      DRAFT: 'draft',
      PUBLISHED: 'published',
      ARCHIVED: 'archived',
      UNPUBLISHED: 'unpublished',
      COMING_SOON: 'coming_soon',
    },
    ALERTS: {
      ALERT_AT_10: 'cert-alert-10',
      ALERT_AT_30: 'cert-alert-30',
      ALERT_AT_45: 'cert-alert-45',
    },
  },
  AUTH_PROVIDERS: [
    {
      color: '4185f4',
      icon: 'https://inedev-uaa.s3.amazonaws.com/federated-login-icons/google.png',
      id: '1fcc86dc-cf5e-4eaa-88d6-02f9c6a9e0fc',
      name: 'Google',
      url: process.env.VUE_APP_GOOGLE_AUTH_URL,
    },
  ],
  SHOP_VIEW: {
    B2B_OFFER: 'teams',
    B2C_OFFER: 'individuals',
  },
  HUBSPOT: {
    HERO_BANNER: {
      ID: process.env.VUE_APP_HUBSPOT_HERO_ID || '',
      URL: `https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLLvy7n2GuE%2BHSQ9UYgAvKK5f6tw5eHBh8XflO68JnMm7GjJFVORJzK5%2Bj8r49G%2B7YoeMkAlU3Dbung5AsGNbRBbYUlR7rGRnWuCNFGC8JARC5s%3D&webInteractiveContentId=${process.env.VUE_APP_HUBSPOT_HERO_ID}&portalId=${HUBSPOT_PORTAL_ID}`,
      IMG: `https://no-cache.hubspot.com/cta/default/${HUBSPOT_PORTAL_ID}/interactive-${process.env.VUE_APP_HUBSPOT_HERO_ID}.png`,
    },
    B2B_BANNER: {
      ID: process.env.VUE_APP_HUBSPOT_B2B_BANNER_ID || '',
      URL: `https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLLX%2FQi5bSxHCLNz7%2FxV%2FEDi6Qg2y2OqxkVlM8HVHDYYM8hs%2FBCQNuba2Qby9%2FB%2BV3kM4VPCPiL6CSVzfcxVNicD9HnRpwpqOcSaA5LQTODhyfCOiionoH8xukNIN5TWyfYmRQ%3D%3D&webInteractiveContentId=${process.env.VUE_APP_HUBSPOT_B2B_BANNER_ID}&portalId=${HUBSPOT_PORTAL_ID}`,
      IMG: `https://no-cache.hubspot.com/cta/default/${HUBSPOT_PORTAL_ID}/interactive-${process.env.VUE_APP_HUBSPOT_B2B_BANNER_ID}.png`,
    },
    SMALL_PRINT: {
      ID: process.env.VUE_APP_HUBSPOT_SMALL_PRINT_ID || '',
      URL: `https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLLX%2FQi5bSxHCLNz7%2FxV%2FEDi6Qg2y2OqxkVlM8HVHDYYM8hs%2FBCQNuba2Qby9%2FB%2BV3kM4VPCPiL6CSVzfcxVNicD9HnRpwpqOcSaA5LQTODhyfCOiionoH8xukNIN5TWyfYmRQ%3D%3D&webInteractiveContentId=${process.env.VUE_APP_HUBSPOT_SMALL_PRINT_ID}&portalId=${HUBSPOT_PORTAL_ID}`,
      IMG: `https://no-cache.hubspot.com/cta/default/${HUBSPOT_PORTAL_ID}/interactive-${process.env.VUE_APP_HUBSPOT_SMALL_PRINT_ID}.png`,
    },
  },
  CART_SAVED_HOURS_LIMIT: 24,
  GUEST_USER_STORAGE_KEY: 'checkout_guest_user',
}

export default CONSTANTS
